export default __webpack_public_path__ + "i18n/translations/translation-tr.f4518515.json";